import Dialog from './Dialog';
import useDialog from './use-dialog';

export default Dialog;
export { useDialog };
